import DefaultButton from "../default.button";
import useVendors from "../../../hooks/vendors/useVendors.vendor.hook";

const FetchRSVendorsButton = () => {
  const { updateVendorsFromRS, isLoading } = useVendors();

  const handleClick = () => {
    if (isLoading) return console.log("Loading...");
    updateVendorsFromRS();
  };
  return (
    <DefaultButton handleClick={handleClick} loading={isLoading}>
      Update Vendors
    </DefaultButton>
  );
};

export default FetchRSVendorsButton;
